<app-banner></app-banner>

<section class="main-section white-bg">
    <div class="width-container">
        <h2 id="error-header" tabindex="-1" class="no-outline" [innerHtml]="'ERROR.PROMOTION_ERROR.HEAD' | translate"></h2>
        <p [innerHtml]="'ERROR.PROMOTION_ERROR.DESC' | translate"></p>
        <button [innerHtml]="'ERROR.PROMOTION_ERROR.CTA_BTN' | translate" (click)="onBack()"></button>
    </div>
</section>